// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VLdTvH_u99wqzB__1Xt2[data-has-many='true'] {
  gap: var(--campaign-header-gap-expanded-has-many);
}
.VLdTvH_u99wqzB__1Xt2[data-has-many='true'] .dWaDbZA1jeUxyGf2SqV7 {
  width: 305px;
}
.VLdTvH_u99wqzB__1Xt2[data-has-many='true'] .U0GyK3s6wFruFFj9E4WA {
  justify-content: space-between;
  padding: 0 2px;
}
.VLdTvH_u99wqzB__1Xt2[data-collapsed='true'] {
  height: 100%;
  padding-bottom: 0;
}
.Wl79wWM981K2mwid1w8c[data-has-many='true'] {
  gap: 15px;
}
.Wl79wWM981K2mwid1w8c[data-has-many='true'][data-collapsed='false'] {
  margin-bottom: 10px;
}
.Wl79wWM981K2mwid1w8c[data-has-many='true'][data-view='single'][data-collapsed='true'] {
  gap: 8px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  /* Nested to match the desktop rule's specificity (both raised by the same ancestor
     qualifier) — otherwise the unconditional desktop rule would outrank this override. */
  .VLdTvH_u99wqzB__1Xt2[data-has-many='true'] .dWaDbZA1jeUxyGf2SqV7 {
    width: 205px;
  }
  .Wl79wWM981K2mwid1w8c[data-has-many='true'][data-collapsed='false'] {
    gap: 10px;
    margin-bottom: 6px;
  }
  .Wl79wWM981K2mwid1w8c[data-has-many='true'][data-view='multi'] {
    margin-bottom: -3px;
  }
  .Wl79wWM981K2mwid1w8c[data-has-many='true'][data-view='multi'][data-collapsed='false'] {
    gap: 5px;
    margin-bottom: 5px;
  }
  .Wl79wWM981K2mwid1w8c[data-has-many='false'][data-view='single'][data-collapsed='true'] {
    margin-bottom: -9px;
    padding-left: 10px;
  }
  .VLdTvH_u99wqzB__1Xt2[data-has-many='true'][data-view='single'][data-variant='card'] {
    gap: var(--campaign-header-gap-expanded-mobile);
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .j49tE1YzWNmK5_matHs8[data-has-many='true'][data-view='single'][data-variant='card'][data-collapsed='false'] {
    font-size: var(--campaign-title-font-has-many-expanded-mobile);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .j49tE1YzWNmK5_matHs8[data-has-many='true'][data-view='single'][data-variant='card'][data-collapsed='false'] {
    font-size: var(--campaign-title-font-has-many-expanded-mobile);
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  /* .separator and .campaignTitleContainer are both descendants of .campaignCardContainer,
     which itself carries these attributes (verified in PrizePopCard.tsx / TournamentCard.tsx). */
  .VLdTvH_u99wqzB__1Xt2[data-has-many='true'][data-view='multi'][data-variant='card'] {
    margin-bottom: var(--campaign-name-prize-margin-bottom-mobile-portrait);
  }
  .VLdTvH_u99wqzB__1Xt2[data-has-many='true'][data-view='multi'][data-variant='card'] .dWaDbZA1jeUxyGf2SqV7 {
    width: 165px;
  }
  .VLdTvH_u99wqzB__1Xt2[data-has-many='true'][data-view='multi'][data-variant='card'] .j49tE1YzWNmK5_matHs8 {
    font-size: var(--campaign-title-font-has-many-multi-portrait);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  /* .separator and .campaignTitleContainer are both descendants of .campaignCardContainer,
     which itself carries these attributes (verified in PrizePopCard.tsx / TournamentCard.tsx). */
  .VLdTvH_u99wqzB__1Xt2[data-has-many='true'][data-view='multi'][data-variant='card'] {
    margin-bottom: var(--campaign-name-prize-margin-bottom-mobile-portrait);
  }
  .VLdTvH_u99wqzB__1Xt2[data-has-many='true'][data-view='multi'][data-variant='card'] .dWaDbZA1jeUxyGf2SqV7 {
    width: 165px;
  }
  .VLdTvH_u99wqzB__1Xt2[data-has-many='true'][data-view='multi'][data-variant='card'] .j49tE1YzWNmK5_matHs8 {
    font-size: var(--campaign-title-font-has-many-multi-portrait);
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/CampaignCard/hasManyStyles.module.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;AACnD;AACA;EACE,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,QAAQ;AACV;AACA;EACE;yFACuF;EACvF;IACE,YAAY;EACd;EACA;IACE,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,QAAQ;IACR,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,+CAA+C;EACjD;AACF;AACA;AAAA;EACE;IACE,8DAA8D;EAChE;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,8DAA8D;EAChE;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;iGAC+F;EAC/F;IACE,uEAAuE;EACzE;EACA;IACE,YAAY;EACd;EACA;IACE,6DAA6D;EAC/D;AACF;AAAA;AAZA;AAAA;AAAA;AAAA;EACE;iGAC+F;EAC/F;IACE,uEAAuE;EACzE;EACA;IACE,YAAY;EACd;EACA;IACE,6DAA6D;EAC/D;AACF;AAAA;AAAA;AAAA","sourcesContent":[".campaignCardContainer[data-has-many='true'] {\n  gap: var(--campaign-header-gap-expanded-has-many);\n}\n.campaignCardContainer[data-has-many='true'] .separator {\n  width: 305px;\n}\n.campaignCardContainer[data-has-many='true'] .topHeaderContainerCollapsed {\n  justify-content: space-between;\n  padding: 0 2px;\n}\n.campaignCardContainer[data-collapsed='true'] {\n  height: 100%;\n  padding-bottom: 0;\n}\n.namePrizeWrapper[data-has-many='true'] {\n  gap: 15px;\n}\n.namePrizeWrapper[data-has-many='true'][data-collapsed='false'] {\n  margin-bottom: 10px;\n}\n.namePrizeWrapper[data-has-many='true'][data-view='single'][data-collapsed='true'] {\n  gap: 8px;\n}\n@media (--campaign-mobile) {\n  /* Nested to match the desktop rule's specificity (both raised by the same ancestor\n     qualifier) — otherwise the unconditional desktop rule would outrank this override. */\n  .campaignCardContainer[data-has-many='true'] .separator {\n    width: 205px;\n  }\n  .namePrizeWrapper[data-has-many='true'][data-collapsed='false'] {\n    gap: 10px;\n    margin-bottom: 6px;\n  }\n  .namePrizeWrapper[data-has-many='true'][data-view='multi'] {\n    margin-bottom: -3px;\n  }\n  .namePrizeWrapper[data-has-many='true'][data-view='multi'][data-collapsed='false'] {\n    gap: 5px;\n    margin-bottom: 5px;\n  }\n  .namePrizeWrapper[data-has-many='false'][data-view='single'][data-collapsed='true'] {\n    margin-bottom: -9px;\n    padding-left: 10px;\n  }\n  .campaignCardContainer[data-has-many='true'][data-view='single'][data-variant='card'] {\n    gap: var(--campaign-header-gap-expanded-mobile);\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .campaignTitleContainer[data-has-many='true'][data-view='single'][data-variant='card'][data-collapsed='false'] {\n    font-size: var(--campaign-title-font-has-many-expanded-mobile);\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) and (--campaign-tablet-portrait-rule) {\n  /* .separator and .campaignTitleContainer are both descendants of .campaignCardContainer,\n     which itself carries these attributes (verified in PrizePopCard.tsx / TournamentCard.tsx). */\n  .campaignCardContainer[data-has-many='true'][data-view='multi'][data-variant='card'] {\n    margin-bottom: var(--campaign-name-prize-margin-bottom-mobile-portrait);\n  }\n  .campaignCardContainer[data-has-many='true'][data-view='multi'][data-variant='card'] .separator {\n    width: 165px;\n  }\n  .campaignCardContainer[data-has-many='true'][data-view='multi'][data-variant='card'] .campaignTitleContainer {\n    font-size: var(--campaign-title-font-has-many-multi-portrait);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"campaignCardContainer": `VLdTvH_u99wqzB__1Xt2`,
	"separator": `dWaDbZA1jeUxyGf2SqV7`,
	"topHeaderContainerCollapsed": `U0GyK3s6wFruFFj9E4WA`,
	"namePrizeWrapper": `Wl79wWM981K2mwid1w8c`,
	"campaignTitleContainer": `j49tE1YzWNmK5_matHs8`
};
export default ___CSS_LOADER_EXPORT___;
